theme.localizationDiscovery = {
  availableMarkets: (typeof window.shopifyMarkets !== 'undefined' && window.shopifyMarkets),

  async getBrowsingContextSuggestions() {
    try {
      const response = await fetch(
        window.Shopify.routes.root + 'browsing_context_suggestions.json' +
        '?country[enabled]=true' +
        `&country[exclude]=${window.Shopify.country}` +
        '&language[enabled]=true' +
        `&language[exclude]=${window.Shopify.locale || 'en'}`
      );
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      return null;
    }
  },

  updateLocalization({ country, language }) {
    const formId = crypto.randomUUID();
    const formHtml = `
      <form id="${formId}" action="/localization" method="POST" hidden>
        <input name="_method" value="PUT" />
        <input name="country_code" value="${country}" />
        <input name="language_code" value="${language}" />
      </form>
    `;
    document.body.insertAdjacentHTML('beforeend', formHtml);
    this.updateTestingInterfaceDisplay(country, language);
    document.getElementById(formId).submit();
  },

  updateTestingInterfaceDisplay(country, language) {
    const testInterface = document.querySelector('.localization-test-interface');
    if (!testInterface) return;
    const currency = this.getCurrencyForCountry(country);
    const currentDisplay = testInterface.querySelector('.localization-test-interface__current');
    if (currentDisplay) {
      currentDisplay.innerHTML = `
        <strong>Current:</strong> ${country} - ${language}<br>
        <strong>Currency:</strong> ${currency}<br>
        <strong>Available Countries:</strong> ${this.getAvailableCountriesText()}<br>
        <strong>Available Country Codes:</strong> ${this.getAvailableCountryCodesText()}
      `;
    }
  },

  getCurrencyForCountry(country) {
    const market = this.availableMarkets[country.toLowerCase()];
    if (market) return market.currency;
    const eurozoneCountries = ['DE', 'FR', 'IT', 'ES', 'NL', 'BE', 'AT', 'PT', 'IE', 'FI', 'GR', 'LU'];
    if (eurozoneCountries.includes(country)) return 'EUR';
    const currencyMap = {
      'DK': 'DKK', 'SE': 'SEK', 'NO': 'NOK', 'CH': 'CHF', 'IN': 'INR', 'MY': 'MYR',
      'TH': 'THB', 'PH': 'PHP', 'ID': 'IDR', 'VN': 'VND', 'KR': 'KRW', 'JP': 'JPY',
      'BR': 'BRL', 'MX': 'MXN', 'AR': 'ARS', 'CL': 'CLP', 'ZA': 'ZAR', 'EG': 'EGP',
      'IL': 'ILS', 'AE': 'AED', 'TR': 'TRY', 'PL': 'PLN', 'CZ': 'CZK', 'CN': 'CNY', 'HK': 'HKD'
    };
    return currencyMap[country] || 'Unknown';
  },

  getAvailableCountriesText() {
    const countries = Object.values(this.availableMarkets).map(market => market.name);
    return countries.join(', ');
  },

  getAvailableCountryCodesText() {
    return Object.keys(this.availableMarkets).join(', ');
  },

  async autoDetectLocalization() {
    try {
      const suggestions = await this.getBrowsingContextSuggestions();
      if (!suggestions || !suggestions.suggestions || !suggestions.suggestions.length) return;

      const suggestion = suggestions.suggestions[0];
      if (!suggestion || !suggestion.parts) return;

      const detectedCountry = suggestion.parts.country?.handle;
      const detectedLanguage = suggestion.parts.language?.handle;
      if (!detectedCountry || !detectedLanguage) return;

      const currentCountry = window.Shopify.country;
      const currentLanguage = window.Shopify.locale || 'en';

      if (detectedCountry !== currentCountry || detectedLanguage !== currentLanguage) {
        const internationalCountries = ['DK', 'SE', 'NO', 'CH', 'IN', 'MY', 'TH', 'PH', 'ID', 'VN', 'KR', 'JP', 'BR', 'MX', 'AR', 'CL', 'ZA', 'EG', 'IL', 'AE', 'TR', 'PL', 'CZ', 'CN', 'HK'];
        if (internationalCountries.includes(detectedCountry)) {
          this.showInternationalModal();
        }
      }
    } catch (error) {
      // silently fail — non-critical feature
    }
  },

  createTestingInterface() {
    if (!window.location.search.includes('debug=localization')) return;

    const testInterface = document.createElement('div');
    testInterface.className = 'localization-test-interface';
    testInterface.innerHTML = `
      <div class="localization-test-interface__content">
        <h3>Localization Testing Interface</h3>
        <p>Test different market locations without VPN:</p>
        <div class="localization-test-interface__markets">
          <h4>Specific Markets:</h4>
          ${Object.entries(this.availableMarkets).filter(([code]) => code !== 'international').map(([code, market]) => `
            <button class="btn btn--small" onclick="theme.localizationDiscovery.testMarket('${code}')">
              ${market.name} (${market.currency})
            </button>
          `).join('')}
          <h4>International Market:</h4>
          <button class="btn btn--small btn--outline" onclick="theme.localizationDiscovery.showInternationalModal()">
            International Market (Select Currency)
          </button>
        </div>
        <div class="localization-test-interface__current">
          <strong>Current:</strong> ${window.Shopify.country} - ${window.Shopify.locale || 'en'}<br>
          <strong>Currency:</strong> ${typeof window.Shopify.currency === 'object' ? window.Shopify.currency?.active || 'Unknown' : window.Shopify.currency || 'Unknown'}<br>
          <strong>Available Countries:</strong> ${window.Shopify.localization?.available_countries?.length || 'Unknown'} countries
        </div>
        <div class="localization-test-interface__reset">
          <button class="btn btn--small btn--danger" onclick="theme.localizationDiscovery.resetToDefault()">
            Reset to Default Market
          </button>
        </div>
      </div>
    `;

    const testStyle = document.createElement('style');
    testStyle.textContent = `
      .localization-test-interface{position:fixed;bottom:20px;left:20px;background:#f8f9fa;padding:16px;z-index:10000;max-width:500px;width:100%;box-shadow:0 4px 12px rgba(0,0,0,.15)}
      .localization-test-interface h3{margin:0 0 8px;font-size:16px}
      .localization-test-interface p{margin:0 0 12px;font-size:12px;color:#666}
      .localization-test-interface__markets h4{margin:12px 0 6px;font-size:13px;font-weight:bold;color:#333}
      .localization-test-interface__markets h4:first-child{margin-top:0}
      .localization-test-interface__markets .btn{font-size:11px;padding:6px 10px;text-align:left;margin-bottom:4px;display:block;width:100%}
      .localization-test-interface__current{font-size:11px;color:#666;padding:8px;background:#fff;border-radius:4px;margin-bottom:8px}
      .localization-test-interface__reset{text-align:center}
      .localization-test-interface__reset .btn--danger{background:#dc3545;color:#fff;border:1px solid #dc3545}
    `;

    document.head.appendChild(testStyle);
    document.body.appendChild(testInterface);
  },

  testMarket(marketCode) {
    const market = this.availableMarkets[marketCode];
    if (!market) return;
    if (['us', 'gb', 'au', 'nz', 'ca', 'sg'].includes(marketCode)) {
      this.updateLocalization({ country: marketCode.toUpperCase(), language: market.language });
    } else if (marketCode === 'eurozone') {
      this.updateLocalization({ country: 'DE', language: market.language });
    } else if (marketCode === 'international') {
      this.showInternationalModal();
    }
  },

  resetToDefault() {
    this.updateLocalization({ country: 'AU', language: 'en' });
  },

  async showInternationalModal() {
    const availableCurrencies = this.getAvailableCurrenciesFromShopify();

    if (!availableCurrencies.length) return;

    const modal = document.createElement('div');
    modal.className = 'international-modal';
    modal.innerHTML = `
      <div class="international-modal__overlay" onclick="theme.localizationDiscovery.closeInternationalModal()"></div>
      <div class="international-modal__content">
        <div class="international-modal__header">
          <h3>Select Currency for International Market</h3>
          <button class="international-modal__close" onclick="theme.localizationDiscovery.closeInternationalModal()">×</button>
        </div>
        <div class="international-modal__body">
          <p>Choose your preferred currency for the International market:</p>
          <form id="international-currency-form" class="international-modal__form">
            <div class="international-modal__select-wrapper">
              <select id="international-currency-select" class="international-modal__select">
                <option value="">Select a currency...</option>
                ${availableCurrencies.map(currency => `
                  <option value="${currency.countryCode}" data-currency="${currency.currencyCode}">
                    ${currency.currencySymbol} ${currency.currencyCode} - ${currency.countryName}
                  </option>
                `).join('')}
              </select>
            </div>
            <div class="international-modal__actions">
              <button type="button" class="btn btn--secondary" onclick="theme.localizationDiscovery.closeInternationalModal()">Cancel</button>
              <button type="submit" class="btn btn--primary" disabled>Switch to Selected Currency</button>
            </div>
          </form>
        </div>
      </div>
    `;

    const style = document.createElement('style');
    style.textContent = `
      .international-modal{position:fixed;top:0;left:0;right:0;bottom:0;z-index:10000;display:flex;align-items:center;justify-content:center}
      .international-modal__overlay{position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5)}
      .international-modal__content{position:relative;background:#fff;border-radius:8px;max-width:500px;width:90%;max-height:80vh;overflow-y:auto;box-shadow:0 10px 25px rgba(0,0,0,.2)}
      .international-modal__header{display:flex;justify-content:space-between;align-items:center;padding:20px;border-bottom:1px solid #e0e0e0}
      .international-modal__header h3{margin:0;font-size:18px}
      .international-modal__close{background:none;border:none;font-size:24px;cursor:pointer;color:#666;padding:0;width:30px;height:30px;display:flex;align-items:center;justify-content:center}
      .international-modal__body{padding:20px}
      .international-modal__form{margin-top:20px}
      .international-modal__select-wrapper{position:relative;margin-bottom:20px}
      .international-modal__select{width:100%;padding:12px 40px 12px 16px;border:1px solid #ddd;border-radius:4px;background:#fff;font-size:14px;cursor:pointer;appearance:none;background-image:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");background-repeat:no-repeat;background-position:right 12px center;background-size:16px}
      .international-modal__select:focus{outline:none;border-color:#007bff;box-shadow:0 0 0 2px rgba(0,123,255,.25)}
      .international-modal__actions{display:flex;gap:12px;justify-content:flex-end}
      .international-modal__actions .btn{padding:10px 20px;font-size:14px}
      .international-modal__actions .btn:disabled{opacity:.5;cursor:not-allowed}
    `;

    document.head.appendChild(style);
    document.body.appendChild(modal);

    const select = document.getElementById('international-currency-select');
    const submitBtn = modal.querySelector('button[type="submit"]');
    const form = document.getElementById('international-currency-form');

    select.addEventListener('change', (e) => {
      submitBtn.disabled = !e.target.value;
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (select.value) this.selectInternationalCurrency(select.value);
    });
  },

  closeInternationalModal() {
    document.querySelector('.international-modal')?.remove();
  },

  getAvailableCurrenciesFromShopify() {
    const el = document.getElementById('localization-country-data');
    if (!el) return [];
    try {
      const countries = JSON.parse(el.textContent);
      return countries.map(c => ({
        countryName: c.name,
        currencyCode: c.currencyCode,
        currencySymbol: c.currencySymbol,
        countryCode: c.countryCode
      }));
    } catch (e) {
      return [];
    }
  },

  selectInternationalCurrency(countryCode) {
    this.closeInternationalModal();
    this.updateLocalization({ country: countryCode, language: 'en' });
  },

  init() {
    if (window.Shopify && window.Shopify.designMode) return;
    this.createTestingInterface();
    setTimeout(() => { this.autoDetectLocalization(); }, 1000);
  }
};

window.addEventListener('load', function() {
  theme.localizationDiscovery.init();
});
